import { render, staticRenderFns } from "./CreateApnZone.vue?vue&type=template&id=0ba036be"
import script from "./CreateApnZone.vue?vue&type=script&lang=js"
export * from "./CreateApnZone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports